const iata = [
    {
        label: "Dublin Airport",
        value : "DUB"
    },
    {
        label : "Cork Airport",
        value: "ORK"
    },
    {
        label: "Bristol Airport",
        value: "BRS"
    },
    {
        label: "Belfast Airport",
        value: "BFS"
    },
];


export default iata;

export const getIataDescription = (code) => {
    let matching = iata.filter((item) => item.value == code);
    if(matching.length == 0) return "";
    return matching[0].label;
};

// IATA -> IANA time zone for airports we operate at.
// Used to render airport-local times in reports regardless of the viewer's browser TZ.
const IATA_TIME_ZONES = {
    DUB: "Europe/Dublin",
    ORK: "Europe/Dublin",
    JER: "Europe/Jersey",
    BFS: "Europe/London",
    EDI: "Europe/London",
    PUJ: "America/Santo_Domingo",
    JED: "Asia/Riyadh",
};

const normalizeIataCode = (code) => {
    if (!code) return undefined;
    if (typeof code === 'object' && code.value) return String(code.value).toUpperCase();
    return String(code).toUpperCase();
};

export const getIataTimeZone = (code) => {
    const normalized = normalizeIataCode(code);
    if (!normalized) return undefined;
    return IATA_TIME_ZONES[normalized];
};

/** Formats a timestamp as DD/MM/YYYY HH:mm in the airport's local time zone. */
export const formatAirportDateTime = (value, code) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    const timeZone = getIataTimeZone(code);
    const parts = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        ...(timeZone ? { timeZone } : {}),
    }).formatToParts(date);
    const get = (type) => parts.find((part) => part.type === type)?.value;
    return `${get('day')}/${get('month')}/${get('year')} ${get('hour')}:${get('minute')}`;
};

/** Formats report timestamps for display/export; falls back to the raw value when not ISO-parseable. */
export const formatReportDateTime = (value, code) => {
    if (value == null || value === '') return '';
    const formatted = formatAirportDateTime(value, code);
    return formatted || String(value);
};
